import { useCallback, useState, useEffect } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import FilterListIcon from "@mui/icons-material/FilterList";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import NodeDeleteButton from "./nodeDeleteButton";

const handleStyle = {
  background: "#ADADAD",
  width: "6px",
  height: "6px",
  borderRadius: "60%",
};

function CustomNode4({ id, isConnectable, data}) {
  const { deleteElements,setNodes } = useReactFlow();
  const [state, setState] = useState({
    message:"",
  });

  useEffect(() => {
    setState(data && data.state);
  }, []);


  
  // const handleChange = (e) => {
  //   const name = e.target.name;
  //   const value = e.target.value;
   
  //   if (state&&state.message!=="") {
  //     setState((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));
  //     setNodes((nodes) =>
  //       nodes.map((node) => {
  //         if (node.id === id) {
  //           return {
  //             ...node,
  //             data: {
  //               state: {...state},
  //             },
  //           };
  //         }

  //         return node;
  //       })
  //     );
  //   } else {
  //     setState((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));
  //     setNodes((nodes) =>
  //       nodes.map((node) => {
  //         if (node.id === id) {
  //           if (node.data !== undefined) {
  //             return {
  //               ...node,
  //               data: {
  //                 ...node.data,
  //                 state: {
  //                   ...node.data?.state,
  //                   [name]: value,
  //                 },
  //               },
  //             };
  //           } else {
  //             return {
  //               ...node,
  //               data: {
  //                 label: "Final node",
  //                 state: {
  //                   message: value,
                    
  //                 },
  //               },
  //             };
  //           }
  //         }
  //         return node;
  //       })
  //     );
  //   }
  
    
  
  // }


  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: {
              ...node.data,
              state: {
                ...node.data?.state,
                [name]: value,
              },
            },
          };
        }
        return node;
      })
    );
  };
  
  
  const handleDeleteNode = useCallback(() => {
    deleteElements({ nodes: [{ id }] });
  }, [id, deleteElements]);

  const [isHover, setIsHover] = useState(false);

 

  return (
    <div
      className="text-updater-node custome3-size"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="custom_header align-items-center">
        <div
          style={{
            padding: "5px",
           
          }}
    
        >
         <WhatsAppIcon
            style={{
              fontSize: "20px",
              color: "#22D954",
              borderRadius: "5px",
              padding: "2px",
              marginTop: "5px",
              backgroundColor: "#fff",
              boxShadow: "0px 0px 2px 0.5px rgba(0, 0, 0, 0.5)",
            }}
          />
        </div>
        <b className="m-1">Final Layout</b>
        {/* delete step (round button + confirmation) */}
        <NodeDeleteButton visible={isHover} onDelete={handleDeleteNode} />
      </div>
      <div className="sub_header">
          <div
            style={{
              marginBottom: "5px",
              paddingBottom: "5px",
              borderBottom: "1px solid #e7e7e7",
              width: "100%",
            }}
            className="d-flex flex-row justify-content-between"
          >
            <span>
              <b>Body</b>
            </span>
           
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <textarea
              type="text"
              name="message"
              value={state ? state.message : ""}
              onChange={(e) => handleChange(e)}
              style={{
                border: "1px solid #e7e7e7",
                borderRadius: "5px",
                padding: "5px",
                outline: "none",
                height: 50,

                resize: "none",
              }}
            />
            </div>
            </div>
 
      <div
        style={{
          fontSize: "7px",
          textAlign: "right",
        }}
        className="footer"
      ></div>

      <Handle
        type="target"
        position={Position.Top}
        id="d"
        style={{
          background: "#ADADAD",
          width: "6px",
          height: "6px",
          borderRadius: "60%",
          left: 10,
        }}
        isConnectable={isConnectable}
      />

      {/* <div
        style={{
          position: "absolute",
          bottom: 10,
          right: 10,
        }}
      >
        <Handle
          type="source"
          position={Position.Bottom}
          id="e"
          style={handleStyle}
          isConnectable={isConnectable}
        />
      </div> */}
    </div>
  );
}

export default CustomNode4;
